// plugins/user-agent.ts
import {useLogger} from '@/utils/logger'

const logger = useLogger('userAgent')
export default defineNuxtPlugin((nuxtApp) => {
  const userAgent = import.meta.server
    ? nuxtApp.ssrContext?.event.headers.userAgent ?? 'SSR'
    : navigator.userAgent

  logger.info('userAgent', userAgent)
  return {
    provide: {
      userAgent
    }
  }
})
